import { TurnOrder } from 'boardgame.io/core';

export default {
  flow: {
    turnOrder: TurnOrder.ANY_ONCE,
  },
};
